import { call, takeLatest } from "redux-saga/effects";
import {
  LOYALTY_CONFIG_GET,
  LOYALTY_CONFIG_UPDATE,
  LOYALTY_MEMBER_GET,
  LOYALTY_EXPIRY_ROWS_GET,
  LOYALTY_REDEEM_PREVIEW,
  LOYALTY_OTP_REQUEST,
  LOYALTY_OTP_VERIFY,
  LOYALTY_OTP_STATUS,
  LOYALTY_REDEEM_APPLY,
  LOYALTY_REDEEM_REVERSE,
  LOYALTY_ADJUST,
  LOYALTY_ENROL,
  LOYALTY_RUNTIME_GET,
} from "../types";
import {
  loyaltyConfigGetApi,
  loyaltyConfigUpdateApi,
  loyaltyMemberGetApi,
  loyaltyExpiryRowsApi,
  loyaltyRedeemPreviewApi,
  loyaltyOtpRequestApi,
  loyaltyOtpVerifyApi,
  loyaltyOtpStatusApi,
  loyaltyRedeemApi,
  loyaltyRedeemReverseApi,
  loyaltyAdjustApi,
  loyaltyEnrolApi,
  loyaltyRuntimeApi,
} from "../apis/loyalty-api";

function* runOk(action, apiCall) {
  try {
    const res = yield call(apiCall, action.data);
    if (res.status === 200) {
      yield action.onSuccess && action.onSuccess(res.data);
    } else {
      yield action.onError && action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError && action.onError(error?.response?.data || error);
  }
}

function* runNoArg(action, apiCall) {
  try {
    const res = yield call(apiCall);
    if (res.status === 200) {
      yield action.onSuccess && action.onSuccess(res.data);
    } else {
      yield action.onError && action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError && action.onError(error?.response?.data || error);
  }
}

function* configGetWorker(action) { yield* runNoArg(action, loyaltyConfigGetApi); }
function* configUpdateWorker(action) { yield* runOk(action, loyaltyConfigUpdateApi); }
function* memberGetWorker(action) { yield* runOk(action, loyaltyMemberGetApi); }
function* expiryRowsGetWorker(action) { yield* runOk(action, loyaltyExpiryRowsApi); }
function* redeemPreviewWorker(action) { yield* runOk(action, loyaltyRedeemPreviewApi); }
function* otpRequestWorker(action) { yield* runOk(action, loyaltyOtpRequestApi); }
function* otpVerifyWorker(action) { yield* runOk(action, loyaltyOtpVerifyApi); }
function* otpStatusWorker(action) { yield* runOk(action, loyaltyOtpStatusApi); }
function* redeemApplyWorker(action) { yield* runOk(action, loyaltyRedeemApi); }
function* redeemReverseWorker(action) { yield* runOk(action, loyaltyRedeemReverseApi); }
function* adjustWorker(action) { yield* runOk(action, loyaltyAdjustApi); }
function* enrolWorker(action) { yield* runOk(action, loyaltyEnrolApi); }
function* runtimeGetWorker(action) { yield* runNoArg(action, loyaltyRuntimeApi); }

export function* loyaltyConfigGetWatcher() { yield takeLatest(LOYALTY_CONFIG_GET, configGetWorker); }
export function* loyaltyConfigUpdateWatcher() { yield takeLatest(LOYALTY_CONFIG_UPDATE, configUpdateWorker); }
export function* loyaltyMemberGetWatcher() { yield takeLatest(LOYALTY_MEMBER_GET, memberGetWorker); }
export function* loyaltyExpiryRowsGetWatcher() { yield takeLatest(LOYALTY_EXPIRY_ROWS_GET, expiryRowsGetWorker); }
export function* loyaltyRedeemPreviewWatcher() { yield takeLatest(LOYALTY_REDEEM_PREVIEW, redeemPreviewWorker); }
export function* loyaltyOtpRequestWatcher() { yield takeLatest(LOYALTY_OTP_REQUEST, otpRequestWorker); }
export function* loyaltyOtpVerifyWatcher() { yield takeLatest(LOYALTY_OTP_VERIFY, otpVerifyWorker); }
export function* loyaltyOtpStatusWatcher() { yield takeLatest(LOYALTY_OTP_STATUS, otpStatusWorker); }
export function* loyaltyRedeemApplyWatcher() { yield takeLatest(LOYALTY_REDEEM_APPLY, redeemApplyWorker); }
export function* loyaltyRedeemReverseWatcher() { yield takeLatest(LOYALTY_REDEEM_REVERSE, redeemReverseWorker); }
export function* loyaltyAdjustWatcher() { yield takeLatest(LOYALTY_ADJUST, adjustWorker); }
export function* loyaltyEnrolWatcher() { yield takeLatest(LOYALTY_ENROL, enrolWorker); }
export function* loyaltyRuntimeGetWatcher() { yield takeLatest(LOYALTY_RUNTIME_GET, runtimeGetWorker); }
